export default __webpack_public_path__ + "static/sushila_story-fa2990a8ca085fd64d5fb54663e65388.png";